module.exports = __webpack_public_path__ + "media/images/iconLeft__accent-5dda040c206c1f5e41afb829b07ae96e.png";